module.exports = __webpack_public_path__ + "img/spicher_and_company_logo.188078e.png";